import { useQuery, useMutation } from 'react-query'
import API from '.'
import { serializeQuery } from './utils'

const BASE_ENDPOINT = '/api/sales-commission-incentive'
const RECIPIENT_ENDPOINT = `${BASE_ENDPOINT}/recipient`
const INCENTIVE_ENDPOINT = `${BASE_ENDPOINT}/incentive`
const PAYOUT_ENDPOINT = `${BASE_ENDPOINT}/payout`
const VISUALIZATION_ENDPOINT = `${BASE_ENDPOINT}/visualization`

const RECIPIENT_KEY = 'sales-recipient'
const INCENTIVE_KEY = 'sales-incentive'
const PAYOUT_KEY = 'sales-payout'
const VISUALIZATION_KEY = 'sales-visualization'

// --- Visualization Hook ---
export const useGetSalesVisualization = (query = {}, config = {}) =>
  useQuery(
    [VISUALIZATION_KEY, query],
    async () => (await API.get(serializeQuery(VISUALIZATION_ENDPOINT, query))).data,
    config
  )

// --- Recipient Hooks ---
export const useGetSalesRecipients = (query = {}, config = {}) =>
  useQuery(
    [RECIPIENT_KEY, query],
    async () => (await API.get(serializeQuery(RECIPIENT_ENDPOINT, query))).data,
    config
  )

export const usePostSalesRecipient = (config = {}) =>
  useMutation((newData) => API.post(RECIPIENT_ENDPOINT, newData), config)

export const usePatchSalesRecipient = (id, config = {}) =>
  useMutation((newData) => API.patch(`${RECIPIENT_ENDPOINT}/${id}`, newData), config)

export const useDeleteSalesRecipient = (config = {}) =>
  useMutation((id) => API.delete(RECIPIENT_ENDPOINT, { data: { id } }), config)

export const useImportSalesRecipients = (config = {}) =>
  useMutation((formData) => API.post(`${RECIPIENT_ENDPOINT}/import`, formData), config)

// --- Incentive Hooks ---
export const useGetSalesIncentives = (query = {}, config = {}) =>
  useQuery(
    [INCENTIVE_KEY, query],
    async () => (await API.get(serializeQuery(INCENTIVE_ENDPOINT, query))).data,
    config
  )

export const usePostSalesIncentive = (config = {}) =>
  useMutation((newData) => API.post(INCENTIVE_ENDPOINT, newData), config)

export const usePatchSalesIncentive = (id, config = {}) =>
  useMutation((newData) => API.patch(`${INCENTIVE_ENDPOINT}/${id}`, newData), config)

export const useDeleteSalesIncentive = (config = {}) =>
  useMutation((id) => API.delete(INCENTIVE_ENDPOINT, { data: { id } }), config)

export const useImportSalesIncentives = (config = {}) =>
  useMutation((formData) => API.post(`${INCENTIVE_ENDPOINT}/import`, formData), config)

export const useExportSalesIncentives = (config = {}) =>
  useMutation(
    (data) => API.post(`${INCENTIVE_ENDPOINT}/export`, data, { responseType: 'blob' }),
    config
  )

// --- Payout Hooks ---

export const useGetSalesPayouts = (query = {}, config = {}) =>
  useQuery(
    [PAYOUT_KEY, query],
    async () => (await API.get(serializeQuery(PAYOUT_ENDPOINT, query))).data,
    config
  )

export const usePostSalesPayout = (config = {}) =>
  useMutation((newData) => API.post(PAYOUT_ENDPOINT, newData), config)

export const useDeleteSalesPayout = (config = {}) =>
  useMutation((id) => API.delete(PAYOUT_ENDPOINT, { data: id }), config)

export const useSendPayoutEmailById = (config = {}) =>
  useMutation((newData) => API.post(`${PAYOUT_ENDPOINT}/send-email`, newData), config)

export const useSendBulkPayoutEmails = (config = {}) =>
  useMutation((newData) => API.post(`${PAYOUT_ENDPOINT}/send-bulk-emails`, newData), config)

export const useExportSalesPayouts = (config = {}) =>
  useMutation(
    (data) => API.post(`${PAYOUT_ENDPOINT}/export`, data, { responseType: 'blob' }),
    config
  )
